import React, { useRef, useEffect } from 'react'
import { string, number, bool, object } from 'prop-types'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { sendClickEventToInsights } from '../../utils/insights'
import {
  ALL,
  ARTICLES,
  FOLDERS,
  PROJECTS,
  IMAGES,
  PRODUCTS,
  COMPETITIONS,
  EVENTS,
  RESPONSIVE_BREAKPOINTS,
  PROFESSIONALS
} from '../../utils/constants'
import Icon from '../ui/icon/Icon'
import { messages } from './messages'
const nonOutsideLinks = [ALL, ARTICLES, FOLDERS, PROJECTS, IMAGES, PRODUCTS, PROFESSIONALS]
const SCROLL_OPTIONS = { behavior: 'smooth', block: 'end', inline: 'center' }
const iconsWithFill = [ALL]

const aggregationsIcons = {
  [ALL]: 'search',
  [PROJECTS]: 'projects',
  [PRODUCTS]: 'products',
  [IMAGES]: 'images',
  [FOLDERS]: 'folders',
  [ARTICLES]: 'articles',
  [COMPETITIONS]: 'competitions',
  [EVENTS]: 'calendar',
  [PROFESSIONALS]: 'expertises'
}

const AggregationItem = ({ isActive = false, link = '#', query = '', text = '', site = 'us' }) => {
  const activeItemRef = useRef(null)

  useEffect(() => {
    if (window.innerWidth < RESPONSIVE_BREAKPOINTS.large && isActive) {
      activeItemRef.current.scrollIntoView(SCROLL_OPTIONS)
    }
  }, [])

  const handleOnClickTracking = () => sendClickEventToInsights('search-tabs', `${text}-aggregation`, text)
  const isInternalLink = nonOutsideLinks.includes(text)
  const sitePath = site === 'us' ? '' : `/${site}`

  const trackingParams = `ad_source=search&ad_medium=${text}_tab`
  const trackedLink = `${link}?${trackingParams}`
  const url = {
    pathname: `${sitePath}/${text}`,
    search: query ? `?q=${query}&${trackingParams}` : `?${trackingParams}`
  }

  const listItemClasses = classnames('aggregations__item', { 'aggregations__item--active': isActive })
  const content = (
    <>
      <Icon svg={aggregationsIcons[text]} withoutFill={!iconsWithFill.includes(text)} />
      <FormattedMessage {...messages[text]} />
    </>
  )

  const renderLink = isInternalLink
    ? <Link to={url} onClick={handleOnClickTracking}>{content}</Link>
    : <a href={trackedLink} onClick={handleOnClickTracking}>{content}</a>
  return (
    <li ref={activeItemRef} className={listItemClasses}>
      {renderLink}
    </li>
  )
}

AggregationItem.propTypes = {
  count: number.isRequired,
  isActive: bool.isRequired,
  link: string,
  style: object,
  query: string,
  text: string.isRequired,
  site: string
}

export default React.memo(AggregationItem)
